import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthHeadersInterceptor } from '@app/shared/interceptors/header.interceptor';

export const INTERCEPTORS = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: AuthHeadersInterceptor,
    multi: true,
  },
];
